import classNames from "classnames";
import Button, { ButtonProps } from "@/components/UI/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/pro-solid-svg-icons";
import { forwardRef, useEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import Tooltip, { TooltipProps } from "../Tooltip";

type CodeRootNode = HTMLDivElement;

interface CodeProps extends React.HTMLAttributes<CodeRootNode> {
  buttonProps?: ButtonProps;
  tooltipProps?: TooltipProps;
}

const Code = forwardRef<CodeRootNode, CodeProps>(
  ({ buttonProps, className, children, tooltipProps, ...props }, ref) => {
    const codeBoxRef = useRef<HTMLDivElement | null>(null);

    const [isShowingTooltip, setIsShowingTooltip] = useState(false);

    useEffect(() => {
      if (!isShowingTooltip) {
        return;
      } else {
        setTimeout(() => {
          setIsShowingTooltip(false);
        }, 2000);
      }
    }, [isShowingTooltip]);

    return (
      <div className={twMerge(classNames("flex flex-col p-12", className))} ref={ref} {...props}>
        <div className="rounded-tl-lg rounded-tr-lg bg-vpGray-100 p-4 font-mono" ref={codeBoxRef}>
          {children}
        </div>
        <Tooltip content="1234" show={isShowingTooltip} showOnHover={false} placement="top" {...tooltipProps}>
          <Button
            color="primary100"
            onClick={async () => {
              const type = "text/plain";

              const blob = new Blob([codeBoxRef.current?.textContent ?? ""], {
                type,
              });
              const data = [new ClipboardItem({ [type]: blob })];

              await navigator.clipboard.write(data);

              setIsShowingTooltip(true);
            }}
            startNode={<FontAwesomeIcon icon={faCopy} />}
            {...buttonProps}
            className={twMerge(classNames("flex-1 rounded-tl-none rounded-tr-none", buttonProps?.className))}
          />
        </Tooltip>
      </div>
    );
  }
);

Code.displayName = Code.name;

export default Code;
